<h1
	class="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl md:pt-1"
>
	<ng-content />
</h1>
